import { render, staticRenderFns } from "./ApiVideo.vue?vue&type=template&id=703e7838&scoped=true&"
import script from "./ApiVideo.vue?vue&type=script&lang=js&"
export * from "./ApiVideo.vue?vue&type=script&lang=js&"
import style0 from "./ApiVideo.vue?vue&type=style&index=0&id=703e7838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e7838",
  null
  
)

export default component.exports